import { gisLayers } from '@lib/map';
import { LayerValue } from '@src/types/maps';

const legendStyle = {
  display: 'inline-block',
  height: 8,
  marginRight: 4,
};

const divStyle: React.CSSProperties = {
  position: 'absolute',
  zIndex: 10,
  top: 675,
  right: 5,
  width: '350px',
  background: '#fff',
  boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
  padding: '3px 20px',
  margin: '20px',
  fontSize: '13px',
  lineHeight: 2,
  color: '#6b6b76',
  textTransform: 'uppercase',
  outline: 'none',
};

interface CompositeMapLegendProps {
  layerValues: LayerValue[] | undefined;
  nutsName: string;
}
function CompositeMapLegend({ layerValues, nutsName }: CompositeMapLegendProps) {
  // console.log('##: ', layerValues);
  if (layerValues)
    return (
      <div style={divStyle}>
        <h3>Your World</h3>
        <h5>Name: {nutsName}</h5>
        {layerValues.map((layerValue) => (
          <div key={layerValue.id}>
            <div style={legendStyle} />
            <span>
              {gisLayers.get(layerValue.id)} - {layerValue.value}
            </span>
          </div>
        ))}
      </div>
    );
}

export default CompositeMapLegend;
